import { memo } from 'react'
import clsx from 'clsx'
import { SxProps } from '@mui/material'

import { Text } from '@/components/Data'
import { inputLabelStyles as styles } from './InputLabel.style'
import { InputLabelProps } from './InputLabel.types'
import { inputClasses } from '../Input.data'

function InputLabel({ sx, className = '', shrinkLabel, ...props }: InputLabelProps) {
  return (
    <Text
      component={'label'}
      sx={[styles.label, sx] as SxProps}
      className={clsx({
        [inputClasses.label.shrink]: shrinkLabel,
        [className]: Boolean(className),
      })}
      {...props}
    />
  )
}

export default memo(InputLabel)
